import { RefObject, useRef, useState } from 'react'

import { ReactComponent as BulbIcon } from '../../assets/icons/bulb.svg'

import BulbTooltip from './BulbTooltip'

import { joinClassNames } from '../../utils/styles'
import styles from './bulb.module.scss'

interface IBulbProps {
    errorMessage?: string
    scrollWrapperRef?: RefObject<HTMLElement>
    status?: boolean
    className?: string
}

function Bulb(props: IBulbProps) {
    const { status, className, scrollWrapperRef, errorMessage } = props

    const iconRef = useRef(null)

    const [isTooltipVisible, setIsTooltipVisible] = useState(false)

    if (status) return null

    return (
        <div className={styles.bulb}>
            {isTooltipVisible && errorMessage && scrollWrapperRef && (
                <BulbTooltip
                    scrollWrapperRef={scrollWrapperRef}
                    iconRef={iconRef}
                    errorMessage={errorMessage}
                />
            )}
            <div ref={iconRef}>
                <BulbIcon
                    onMouseOver={() => setIsTooltipVisible(true)}
                    onMouseOut={() => setIsTooltipVisible(false)}
                    className={joinClassNames(styles.bulb__icon, className)}
                />
            </div>
        </div>
    )
}

export default Bulb
